exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Badge-Badge-Badge{background-color:#f00540;color:#fff;padding:3.2px 3px;padding:.2rem .1875rem;border-radius:50%;font-size:10px;font-size:.625rem;line-height:1;position:absolute;right:-12px;right:-.75rem;top:16px;top:1rem;min-width:16px;min-width:1rem;text-align:center}.Badge-Badge-Badge:empty{display:none}@media (min-width:920px){.Badge-Badge-Badge{top:2rem}}.Badge-Badge-Badge__history{right:8px;right:.5rem;top:24px;top:1.5rem}.Badge-Badge-Badge__history:empty{display:none}.Badge-Badge-Badge__inline{position:static;display:inline-block;padding:4.8px 3.2px 3.2px;padding:.3rem .2rem .2rem;font-size:12px;font-size:.75rem;margin-right:5.6px;margin-right:.35rem;min-width:21.6px;min-width:1.35rem;-ms-flex-negative:0;flex-shrink:0}.Badge-Badge-Badge__inline:empty{display:inherit;padding:0;width:21.6px;width:1.35rem;height:21.6px;height:1.35rem;background-color:transparent;border:1px solid #f00540;opacity:.3}", ""]);

// exports
exports.locals = {
	"Badge": "Badge-Badge-Badge",
	"Badge__history": "Badge-Badge-Badge__history",
	"Badge__inline": "Badge-Badge-Badge__inline"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-rules-2!./node_modules/postcss-loader/lib??ref--2-rules-3!./src/components/Badge/Badge.css
// module id = 1047
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20